const DisplayPosition = {
  EMAIL: 'email',
  SUBMISSION: 'submission',
} as const;

export default DisplayPosition;
